/**
 * Client-side aggregates for seller inventory dashboard (from `inventoryAvailability` on my-published cards).
 */

function n(v) {
  const x = Number(v);
  return Number.isFinite(x) ? x : 0;
}

/**
 * @param {object[]} items — `fetchMyPublishedInfrastructureListings` rows
 * @returns {object}
 */
export function aggregateInventoryKpisFromMyPublishedItems(items) {
  const list = Array.isArray(items) ? items : [];
  let trackedListings = 0;
  let sumTotalUnits = 0;
  let sumAvailUnits = 0;
  let sumTotalArea = 0;
  let sumAvailArea = 0;
  let sumTotalCap = 0;
  let sumAvailCap = 0;
  let partialOrFull = 0;

  for (const it of list) {
    const ia = it?.inventoryAvailability;
    if (!ia?.inventoryManaged) continue;
    trackedListings += 1;
    const st = String(ia.listingAvailabilityState || '');
    if (st === 'partially_available' || st === 'fully_leased' || st === 'blocked') partialOrFull += 1;

    const lines = Array.isArray(ia.inventoryLines) ? ia.inventoryLines : [];
    for (const ln of lines) {
      if (ln.totalUnits != null && Number.isFinite(Number(ln.totalUnits))) {
        sumTotalUnits += n(ln.totalUnits);
        sumAvailUnits += n(ln.effectiveAvailableUnits);
      }
      if (ln.totalArea != null && Number.isFinite(Number(ln.totalArea))) {
        sumTotalArea += n(ln.totalArea);
        sumAvailArea += n(ln.effectiveAvailableArea);
      }
      if (ln.totalCapacity != null && Number.isFinite(Number(ln.totalCapacity))) {
        sumTotalCap += n(ln.totalCapacity);
        sumAvailCap += n(ln.effectiveAvailableCapacity);
      }
    }
  }

  const occUnits = sumTotalUnits > 0 ? Math.min(100, Math.round(((sumTotalUnits - sumAvailUnits) / sumTotalUnits) * 1000) / 10) : null;
  const vacUnits = sumTotalUnits > 0 ? Math.min(100, Math.round((sumAvailUnits / sumTotalUnits) * 1000) / 10) : null;

  return {
    trackedListings,
    listingsTotal: list.length,
    partialOrFullOccupancyListings: partialOrFull,
    sumTotalUnits,
    sumAvailUnits,
    sumTotalArea,
    sumAvailArea,
    sumTotalCap,
    sumAvailCap,
    occupancyPctUnits: occUnits,
    vacancyPctUnits: vacUnits,
  };
}

function isoDate(d) {
  if (d == null) return '';
  const s = String(d).slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(s) ? s : '';
}

/**
 * @param {object[]} allocations — seller inventory API `allocations` rows
 * @param {{ withinDays?: number }} opts
 */
export function filterAllocationsExpiringSoon(allocations, opts = {}) {
  const within = Number(opts.withinDays) || 90;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const horizon = new Date(today);
  horizon.setDate(horizon.getDate() + within);

  const list = Array.isArray(allocations) ? allocations : [];
  return list.filter((a) => {
    const st = String(a.allocation_status || '').toLowerCase();
    if (!['reserved', 'confirmed'].includes(st)) return false;
    const end = isoDate(a.lease_end_date);
    if (!end) return false;
    const ed = new Date(`${end}T12:00:00`);
    return ed >= today && ed <= horizon;
  });
}
